import { request } from '@umijs/max';
import { AUTH_RESULT_CODES } from '@/constants/authResultCodes';
import { clearTokenBundle, loadTokenBundle } from '@/utils/auth';
import type { ResultResponse } from './emailCode';

/** 退出登录 POST /auth/logout（需 Bearer access_token） */
export async function logout(options?: { [key: string]: unknown }): Promise<void> {
  const token = loadTokenBundle()?.accessToken;
  try {
    if (token) {
      const res = await request<ResultResponse<void>>('/auth/logout', {
        method: 'POST',
        skipErrorHandler: true,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        ...(options || {}),
      });
      if (res?.code !== AUTH_RESULT_CODES.SUCCESS) {
        // 服务端登出失败仍继续本地清理
      }
    }
  } catch {
    // 网络或服务异常时仍本地登出
  } finally {
    clearTokenBundle();
  }
}
